export default "__VITE_ASSET__B$1TOe$b__"